import { Component, OnInit, Pipe, PipeTransform, ViewEncapsulation, ViewChild, ViewChildren, AfterViewInit, TemplateRef, ViewContainerRef, QueryList } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { Chart } from 'angular-highcharts';
import { ChartType, ChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import { ReportServiceService } from 'src/app/services/report-service.service';
import { NgIfContext } from '@angular/common';
import { Chart } from 'angular-highcharts';
import { HttpClient } from "@angular/common/http";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as Highcharts from 'highcharts';
import { StockChart } from 'angular-highcharts';
import usAll from "../../../../assets/js/indiaMapAll.js";
// import * as alasql  from 'alasql';
import mapFactory from 'highcharts/modules/map';
mapFactory(Highcharts);
var alasql = require('alasql');

var db = new alasql.Database();

import itemFactory from 'highcharts/modules/item-series';
import { stringify } from 'querystring';
itemFactory(Highcharts);
declare var require: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);

export interface reportsType {
  paramName: any;
  paramValue: any;
}

export interface TableHeader {
  headerName: any;
  field: any;
}

@Component({
  selector: 'app-static-report',
  templateUrl: './static-report.component.html',
  styleUrls: ['./static-report.component.css']
})
export class StaticReportComponent implements OnInit {
  stock: StockChart;
  // All variables;
  public rowCheck: boolean = true;
  filterValue: number;
  public staticValues: any;
  public staticReportValues: any;
  public listColumeNames: any;
  public columnValues: any;
  allStateEnable: boolean = true;
  state: any;
  district: any;
  stateCode: String;
  yearValue:String="2018-19";
  StateValue: String = 'All';
  DistValue: String = 'All';
  thlabel: String = "State Name";
  conditionObj = {};
  masterCondition = {};
  yearList: any[number];
  public selectedDeviceObj: any;
  chart: Chart;
  ChartName: string;
  jsonColumnName:string;
  public gridApi;
   gridColumnApi:any;
   testingVar:string;
   modalRef:any;
   showGrid:boolean=false;
   uniHeader:String;
   tag:String;
   filterReportCount:number;
   reportCode:any;
  // public modules: Module[] = AllModules;

  private columnDefs;
  private defaultColDef;
  private defaultColDef1;
  private autoGroupColumnDef;
  private rowData: any;
  private agGridColumnDefs1;

  private agGridColumnDefs4;
  private defaultColDef4;
  private columnDefsClassCondition
  private frameworkComponents;
  private defaultColDefClassCondition;
  //  PGI RAW VALUES OF UDISE
  private agGridColumnDefs5;
  private defaultColDef5;
  private universalAgGridColumnDefs:any[]=[];;
  private universalColDefs;
  private gridOptions;
  // High Charts
  gradVariable:String="agGrid";

  titleText: string;
  subTitleText: string;
  chartData1: any[] = [];
  chartData2: any[] = [];
  chartTempData: any[] = [];
  univerSalChartType:String;
  universalCharData:any[]=[];
  universalChartText:String;

  // state label report
  reportType: reportsType;
  Indaidata:any[]=[];
  mapArray:any;
  TableHeaders:TableHeader;

  // Static Report
   staticReportDependency:any;
   category1 : Number;
   category2 : Number;
   category3 : Number;
   category4 : Number;
   category5 : Number;
   category6 : Number;
   category7 : Number;
   category8 : Number;
   category10 : Number;
   category11: Number;

  public options: any = {
    chart: {
      type: 'spline'
    },
    renderto: "chart1",
    title: {
      text: 'School History Graph'
    },
    subtitle: {
      text: 'School History Graph'
    },
    xAxis: {
      type: 'date',
      min: 1700,
      max: 2025,
      title: {
        text: 'Date'
      }
    },
    yAxis: {
      title: {
        text: 'Snow depth (m)'
      },
      min: 0
    },
    tooltip: {
      headerFormat: '<b>{series.name}</b><br>',
      pointFormat: '{point.x}:{point.y:.2f} schools'
    },

    plotOptions: {
      series: {
        marker: {
          enabled: true
        }
      }
    },
    colors: ['#6CF', '#39F', '#06C', '#036', '#000'],
    series: [{
      name: "Cumulative School Year wise",
      data: this.chartData1
    }
    ],

    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          plotOptions: {
            series: {
              marker: {
                radius: 2.5
              }
            }
          }
        }
      }]
    }
  }

  public options2: any = {
    chart: {
      type: 'spline'
    },
    renderto: "chart2",
    title: {
      text: 'School History Graph'
    },
    subtitle: {
      text: 'School History Graph'
    },
    xAxis: {
      type: 'date',
      min: 1700,
      max: 2025,
      title: {
        text: 'Date'
      }
    },
    yAxis: {
      title: {
        text: 'Snow depth (m)'
      },
      min: 0
    },
    tooltip: {
      headerFormat: '<b>{series.name}</b><br>',
      pointFormat: '{point.x}:{point.y:.2f} schools'
    },

    plotOptions: {
      series: {
        marker: {
          enabled: true
        }
      }
    },
    colors: ['#6CF', '#39F', '#06C', '#036', '#000'],
    series: [{
      name: "Year wise school",
      data: this.chartData2
    }
    ],

    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          plotOptions: {
            series: {
              marker: {
                radius: 2.5
              }
            }
          }
        }
      }]
    }
  }
  

  public indiaGraphoption:any={
    chart: {
      map: 'countries/in/custom/in-all-disputed'
  },
  title: {
      text: 'Highmaps basic demo'
  },
  subtitle: {
      text: 'Source map: <a href="http://code.highcharts.com/mapdata/countries/in/custom/in-all-disputed.js">India with disputed territories</a>'
  },
  mapNavigation: {
      enabled: true,
      buttonOptions: {
          verticalAlign: 'bottom'
      }
  },
  colorAxis: {
      min: 0
  },
  series: [{
      data: this.Indaidata,
      mapData: usAll,
      name: 'Random data',
      states: {
          hover: {
              color: '#BADA55'
          }
      },
      dataLabels: {
          enabled: true,
          format: '{point.name}'
      }
  }]
  }


  public noSchoolChartOption:any={
    chart: {
      type: 'item',  
  },
  title: {
      text: 'Highcharts item chart'
  },
  subtitle: {
      text: 'Category Wise School(500 Scale) visualization'
  },
  legend: {
      labelFormat: '{name} <span style="opacity: 0.4">{y}</span>'
  },
  series: [{
      name: 'Representatives',
      keys: ['name', 'y', 'color', 'label'],
      data:this.Indaidata,
      itemData:usAll,
      dataLabels: {
          enabled: false,
          format: '{point.label}'
      },
      // Circular options
      center: ['50%', '88%'],
      size: '170%',
      startAngle: -100,
      endAngle: 100
  }]
  }


  public univerPieChartOption:any={
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie'
    },
    title: {
      text: "Category wise School %"
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %'
        }
      }
    },
    series: [{
      name: 'Brands',
      colorByPoint: true,
      data:
      this.universalCharData
      
      // [{
      //   name: 'Chrome',
      //   y: 61.41,
      //   // sliced: true,
      //   // selected: true
      // }, {
      //   name: 'Internet Explorer',
      //   y: 11.84
      // }, {
      //   name: 'Firefox',
      //   y: 10.85
      // }, {
      //   name: 'Edge',
      //   y: 4.67
      // }, {
      //   name: 'Safari',
      //   y: 4.18
      // }, {
      //   name: 'Sogou Explorer',
      //   y: 1.64
      // }, {
      //   name: 'Opera',
      //   y: 1.6
      // }, {
      //   name: 'QQ',
      //   y: 1.2
      // }, {
      //   name: 'Other',
      //   y: 2.61
      // }]
    }]
  }

  // End of high charts
  constructor(private modalService: NgbModal, private reportService: ReportServiceService, private http: HttpClient, private ngxLoader: NgxUiLoaderService) {
    this.agGridColumnDefs1 = [
      {
        headerName: "Year",
        field: "estd_year",
        // aggFunc: "sum"
      },
      {
        headerName: "New School Established",
        field: "noofschool",
        // aggFunc: "sum"
      },
      {
        headerName: "Cumalative Number Of School",
        field: "cumulative_sum",
        // aggFunc: "sum"
      },
    ]
    this.defaultColDef1 = {
      width: 525,
      sortable: true,
      resizable: true
    };

    this.columnDefs = [
      {
        headerName: "primary Boys",
        field: "primary_b",
        aggFunc: "sum"
      },
      {
        headerName: "Primary Girls",
        field: "primary_g",
        aggFunc: "sum"
      },


      {
        headerName: "Upper Primary Boys",
        field: "upper_primary_b",
        aggFunc: "sum"
      },
      {
        headerName: "Upper Primary Girls",
        field: "upper_primary_g",
        aggFunc: "sum"
      },
      {
        headerName: "secondary Boys",
        field: "secondary_b",
        aggFunc: "sum"
      },
      {
        headerName: "secondary Girls",
        field: "secondary_g",
        aggFunc: "sum"
      },
      {
        headerName: "Higher Secondary Boys",
        field: "higher_secondary_b",
        aggFunc: "sum"
      },
      {
        headerName: "Higher Secondary Girls",
        field: "higher_secondary_g",
        aggFunc: "sum"
      },
      {
        field: "state_name",
        rowGroup: true,
        hide: true
      },
      {
        field: "management",
        rowGroup: true
        // hide: true
      }
    ];
    // this.defaultColDef = {
    //   width: 150,
    //   sortable: true,
    //   resizable: true
    // };


    this.agGridColumnDefs4 = [
      {
        headerName: "udise_sch_code",
        field: "udise_sch_code",
        // aggFunc: "sum"
      },
      {
        headerName: "ac_year",
        field: "ac_year",
        // aggFunc: "sum"
      },

      {
        headerName: "'bld_status",
        field: "'bld_status",
        // aggFunc: "sum"
      },

      {
        headerName: "bld_blk_tot",
        field: "bld_blk_tot",
        // aggFunc: "sum"
      },

      {
        headerName: "'bld_blk",
        field: "'bld_blk",
      },

      {
        headerName: "bld_blk_ppu",
        field: "bld_blk_ppu",
      },
     
    ]
    this.defaultColDef4 = {
      width: 300,
      sortable: true,
      resizable: true
    };
    //   PGI RAW VALUES
    this.agGridColumnDefs5 = [
     
      {
        headerName: "serial",
        field: "serial",
        // aggFunc: "sum"
      },
      {
        headerName: "Question",
        field: "name",
      },
     
      {
        headerName: "Response One",
        field: "r1",
      },
      {
        headerName: "Value",
        field: "v1",
      },
  
      {
        headerName: "Response Two",
        field: "r2",
      },
      {
        headerName: "Value ",
        field: "v2",
      },
   
    ]
    this.defaultColDef5 = {
      width: 300,
      sortable: true,
      resizable: true
    };



    this.columnDefsClassCondition = [
      {
        headerName: "State Name",
        field:"state_name"
      },
      {
        headerName: "Total School",
        field:"total_school"
      },
      {
        headerName: "Class Rooms",
        children: [
          {
            headerName: "Total",
            field: "total_classroom",
            width: 90
          },
          {
            headerName: "Minor Repair",
            field: "tot_clsrm_minor",
            width: 110
          },
          {
            headerName: "Major Repair",
            field: "tot_clsrm_major",
            width: 110,
            columnGroupShow: "open"
          },
          {
            headerName: "Good Condition",
            field: "goodcondition",
            width: 100,
            columnGroupShow: "open"
          }
         
        ]
      }
    ];
    // this.frameworkComponents = { customHeaderGroupComponent: CustomHeaderGroup };
    this.defaultColDefClassCondition = {
      width: 300,
      resizable: true,
      sortable: true,
      filter: true,
      
    };

    this.universalColDefs = {
      width: 300,
      resizable: true,
    };
     this.gridOptions = {
      columnDefs: this.universalColDefs,
      animateRows: true,
      enableRangeSelection: true,
      enableSorting: true,
      enableFilter: true,
      suppressAggFuncInHeader: true
    };

    
// this.gridApi.setColumnGroupOpened();
  

// this.gridColumnApi.addEventListener('click', function() {
//   alert("1");
//   //params.showColumnMenu(myMenuButton);
// });



  }

  onCellClicked(event){
// alert("called");
// alert(event.columnApi.getColumn("no_of_school").visible);
  }
  
  onSelectionChanged(event){
// alert("selection")
  }

  onSortChanged(event){
// alert("1");
  }
  onFilterChanged(event){
// alert("2");
  } 
  onFilterModified(event){
// alert("3");
  }
  closedModal(){
    // alert("called closed modal");
    // this.modalRef.close();
    // this.gridColumnApi.hideOverlay()
    this.showGrid=false;
    // this.agGrid9.destroy();
    // this.modalService.;
    // this.gridApi.reset();
    // this.gridApi.destroy();
    // this.gridColumnApi.destroy();

  }
  onColumnVisible(event,id){
    if(id==='id9'){
      this.jsonColumnName="";
    for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
      if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school"){
       this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
      }
    }
    if(this.jsonColumnName  !=""){
      this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
    }
      let res = alasql("SELECT SUM(no_of_school) AS no_of_school,school_type,loc_name,sch_mgmt_name,min_mgmt_name,category_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
       this.rowData=res;
    }else if (id==='id10'){
      this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(no_of_school) AS no_of_school,school_type,loc_name,sch_mgmt_name,min_mgmt_name,category_name,state_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
         this.rowData=res;
    }else if(id==='id11'){
    this.jsonColumnName="";
    for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
      if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school" && this.universalAgGridColumnDefs[i].field !=="total_student" && this.universalAgGridColumnDefs[i].field !=="total_boys" && this.universalAgGridColumnDefs[i].field !=="total_girls" ){
       this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
      }
    }
    if(this.jsonColumnName  !=""){
      this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
    }
      let res = alasql("SELECT SUM(no_of_school) AS no_of_school,SUM(total_student) AS total_student,SUM(total_boys) AS total_boys,SUM(total_girls) AS total_girls,school_type,loc_name,sch_mgmt_name,min_mgmt_name,category_name,state_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
       this.rowData=res;

    }else if(id==='id12'){
      this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school" && this.universalAgGridColumnDefs[i].field !=="total_student" && this.universalAgGridColumnDefs[i].field !=="number_of_teacher"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(no_of_school) AS no_of_school,SUM(total_student) AS total_student,SUM(number_of_teacher) AS number_of_teacher,school_type,loc_name,sch_mgmt_name,min_mgmt_name,category_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
         this.rowData=res;
    }else if(id==='id13'){
    this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school" && this.universalAgGridColumnDefs[i].field !=="total_student" && this.universalAgGridColumnDefs[i].field !=="total_boys" && this.universalAgGridColumnDefs[i].field !=="total_girls" ){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(no_of_school) AS no_of_school,SUM(total_student) AS total_student,SUM(total_boys) AS total_boys,SUM(total_girls) AS total_girls,school_type,loc_name,sch_mgmt_name,min_mgmt_name,category_name,state_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
        this.rowData=res;
    }else if(id==='id14'){
    this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school" && this.universalAgGridColumnDefs[i].field !=="total_student" && this.universalAgGridColumnDefs[i].field !=="number_of_teacher"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(no_of_school) AS no_of_school,SUM(total_student) AS total_student,SUM(number_of_teacher) AS number_of_teacher,state_name,school_type,loc_name,sch_mgmt_name,min_mgmt_name,category_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
        this.rowData=res;
    }else if(id==='id15'){
    this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school" && this.universalAgGridColumnDefs[i].field !=="gen" && this.universalAgGridColumnDefs[i].field !=="sc" && this.universalAgGridColumnDefs[i].field !=="st" && this.universalAgGridColumnDefs[i].field !=="obc" && this.universalAgGridColumnDefs[i].field !=="orc" && this.universalAgGridColumnDefs[i].field !=="othre"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(school_count) AS school_count,SUM(gen) AS gen,SUM(sc) AS sc,SUM(st) AS st,SUM(obc) AS obc,SUM(orc) AS orc,SUM(othre) AS othre,min_mgmt_name,category_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
        this.rowData=res;
    }else if(id==='id16'){

    }else if(id==='id17'){

    }else if(id==='id18'){
    this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="school_count" && this.universalAgGridColumnDefs[i].field !=="number_of_teacher_male" && this.universalAgGridColumnDefs[i].field !=="number_of_teacher_female"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(school_count) AS school_count,SUM(number_of_teacher_male) AS number_of_teacher_male,SUM(number_of_teacher_female) AS number_of_teacher_female,min_mgmt_name,category_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
        this.rowData=res;
    }else if(this.reportCode==='R28'){
      this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(no_of_school) AS no_of_school,bld_status_name,category_name,sch_mgmt_18_19,sch_mgmt_name,report_mgmt_name,location_r_u FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
        this.rowData=res;
    }else if(this.reportCode==='R29'){
      this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(no_of_school) AS no_of_school,bld_status_name,category_name,sch_mgmt_name,report_mgmt_name,location_r_u,state_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
        this.rowData=res;
    }else if(this.reportCode==='R30'){
      this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(no_of_school) AS no_of_school,bld_status_name,category_name,sch_mgmt_name,report_mgmt_name,location_r_u,state_name,district_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
        this.rowData=res;
    }else if(this.reportCode==='R31'){
      this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(no_of_school) AS no_of_school,bld_status_name,category_name,sch_mgmt_name,report_mgmt_name,location_r_u FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
        this.rowData=res;
    }else if(this.reportCode==='R32'){
      this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(no_of_school) AS no_of_school,bld_status_name,category_name,sch_mgmt_name,report_mgmt_name,location_r_u FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
        this.rowData=res;
    }else if(this.reportCode==='R33'){
      this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(no_of_school) AS no_of_school,bld_status_name,category_name,sch_mgmt_name,report_mgmt_name,location_r_u,state_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
        this.rowData=res;
    }else if(this.reportCode==='R34'){
      this.jsonColumnName="";
      for(let i=0;i<this.universalAgGridColumnDefs.length;i++){
        if(event.columnApi.getColumn(this.universalAgGridColumnDefs[i].field).visible && this.universalAgGridColumnDefs[i].field !=="no_of_school"){
         this.jsonColumnName +=this.universalAgGridColumnDefs[i].field+",";
        }
      }
      if(this.jsonColumnName  !=""){
        this.jsonColumnName ="GROUP BY "+this.jsonColumnName;
      }
        let res = alasql("SELECT SUM(no_of_school) AS no_of_school,bld_status_17_18,bld_status_18_19,report_mgmt_name FROM ? "+this.jsonColumnName.replace(/,\s*$/,""),[this.columnValues]);
        this.rowData=res;
    }


    
    // else if(event.columnApi.getColumn("min_mgmt_name").visible==false){
          // this.rowData=[];
          // for(let i=0;i<this.columnValues.length;i++){
          //         if(this.columnValues[i].sch_category_id=="1"){
          //           if(this.rowData[0] !==undefined && this.rowData[0] !==null){
          //             this.rowData[0]={"school_count":(+this.rowData[0].school_count)+(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.rowData[0].number_of_teacher_male)+(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.rowData[0].number_of_teacher_female)+(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }else{
          //             this.rowData[0]={"school_count":(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }
          //         }else if(this.columnValues[i].sch_category_id=="2"){
          //           if(this.rowData[1] !==undefined && this.rowData[1] !==null){
          //             this.rowData[1]={"school_count":(+this.rowData[1].school_count)+(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.rowData[1].number_of_teacher_male)+(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.rowData[1].number_of_teacher_female)+(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }else{
          //             this.rowData[1]={"school_count":(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }
          //         }else if(this.columnValues[i].sch_category_id=="3"){
          //           if(this.rowData[2] !==undefined && this.rowData[2] !==null){
          //             this.rowData[2]={"school_count":(+this.rowData[2].school_count)+(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.rowData[2].number_of_teacher_male)+(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.rowData[2].number_of_teacher_female)+(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }else{
          //             this.rowData[2]={"school_count":(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }
          //         }else if(this.columnValues[i].sch_category_id=="4"){
          //           if(this.rowData[3] !==undefined && this.rowData[3] !==null){
          //             this.rowData[3]={"school_count":(+this.rowData[3].school_count)+(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.rowData[3].number_of_teacher_male)+(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.rowData[3].number_of_teacher_female)+(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }else{
          //             this.rowData[3]={"school_count":(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }
          //         }else if(this.columnValues[i].sch_category_id=="5"){
          //           if(this.rowData[4] !==undefined && this.rowData[4] !==null){
          //             this.rowData[4]={"school_count":(+this.rowData[4].school_count)+(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.rowData[4].number_of_teacher_male)+(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.rowData[4].number_of_teacher_female)+(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }else{
          //             this.rowData[2]={"school_count":(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }
          //         }else if(this.columnValues[i].sch_category_id=="6"){
          //           if(this.rowData[5] !==undefined && this.rowData[5] !==null){
          //             this.rowData[5]={"school_count":(+this.rowData[5].school_count)+(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.rowData[5].number_of_teacher_male)+(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.rowData[5].number_of_teacher_female)+(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }else{
          //             this.rowData[5]={"school_count":(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }
          //         }else if(this.columnValues[i].sch_category_id=="7"){
          //           if(this.rowData[6] !==undefined && this.rowData[6] !==null){
          //             this.rowData[6]={"school_count":(+this.rowData[6].school_count)+(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.rowData[6].number_of_teacher_male)+(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.rowData[6].number_of_teacher_female)+(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }else{
          //             this.rowData[6]={"school_count":(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }
          //         }else if(this.columnValues[i].sch_category_id=="8"){
          //           if(this.rowData[7] !==undefined && this.rowData[7] !==null){
          //             this.rowData[7]={"school_count":(+this.rowData[7].school_count)+(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.rowData[7].number_of_teacher_male)+(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.rowData[7].number_of_teacher_female)+(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }else{
          //             this.rowData[7]={"school_count":(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }
          //         }else if(this.columnValues[i].sch_category_id=="10"){
          //           if(this.rowData[8] !==undefined && this.rowData[8] !==null){
          //             this.rowData[8]={"school_count":(+this.rowData[8].school_count)+(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.rowData[8].number_of_teacher_male)+(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.rowData[8].number_of_teacher_female)+(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }else{
          //             this.rowData[8]={"school_count":(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }
          //         }else if(this.columnValues[i].sch_category_id=="11"){
          //           if(this.rowData[9] !==undefined && this.rowData[9] !==null){
          //             this.rowData[9]={"school_count":(+this.rowData[9].school_count)+(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.rowData[9].number_of_teacher_male)+(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.rowData[9].number_of_teacher_female)+(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }else{
          //             this.rowData[9]={"school_count":(+this.columnValues[i].school_count),"number_of_teacher_male":(+this.columnValues[i].number_of_teacher_male),"number_of_teacher_female":(+this.columnValues[i].number_of_teacher_female),"category_name":this.columnValues[i].category_name};
          //           }
          //         }
          // }

          // alert(JSON.stringify(this.rowData));
        // }
        
        // else{
        //   this.rowData=this.columnValues;
        // }
        // event.columnApi.enableRowGroup=true;
        // event.columnApi.rowGroup=true
        // event.columnApi.prototype.setRowGroupColumns = function (colKeys) {     event.columnApi.setRowGroupColumns(colKeys); };
        // event.columnApi.setRowGroupColumns("category_name");
        // event.columnApi.getColumn("category_name").setRowGroupActive(true);
        // event.columnApi.setColumnAggFunc("number_of_teacher_female", "sum");
  }

  onColumnPivotModeChanged(event){
// alert("changed");
  }
  onColumnPivotChanged(event){
// alert("changed1");
  }

  // setColumnGroupOpened(){
  //   alert("called");
  // }






  onGridReady(params) {
//  alert("on grid ready");
    this.gridApi = params.api;
    this.gridColumnApi =params.columnApi;
    this.testingVar="A";
    //  alert(this.gridColumnApi.getColumn("no_of_school").visible);
  }

  
  // @ViewChild(TemplateRef) longContent: TemplateRef<any>;
  @ViewChild('longContent', { static: true }) longContent: TemplateRef<any>;
  @ViewChild('longPieContent', { static: true }) longPieContent: TemplateRef<any>;
  @ViewChild('agGrid3', { static: true }) agGrid3: TemplateRef<any>;
  @ViewChild('chartId1', { static: true }) chartId1: TemplateRef<any>;
  @ViewChild('agGrid1', { static: true }) agGrid1: TemplateRef<any>;
  @ViewChild('chartId4', { static: true }) chartId4: TemplateRef<any>;
  @ViewChild('agGrid4', { static: true }) agGrid4: TemplateRef<any>;

  //   PGI UDISE RAW VALUE
  @ViewChild('chartId5', { static: true }) chartId5: TemplateRef<any>;
  @ViewChild('agGrid5', { static: true }) agGrid5: TemplateRef<any>;
  @ViewChild('chartId6', { static: true }) chartId6: TemplateRef<any>;
  @ViewChild('agGrid6', { static: true }) agGrid6: TemplateRef<any>;
  @ViewChild('agGrid7', { static: true }) agGrid7: TemplateRef<any>;
  @ViewChild('chartId7', { static: true }) chartId7: TemplateRef<any>;
  @ViewChild('agGrid8', { static: true }) agGrid8: TemplateRef<any>;
  @ViewChild('agGrid9', { static: true }) agGrid9: TemplateRef<any>;
  @ViewChild('agGrid10', { static: true }) agGrid10: TemplateRef<any>;
  @ViewChild('agGrid11', { static: true }) agGrid11: TemplateRef<any>;
  @ViewChild('agGrid12', { static: true }) agGrid12: TemplateRef<any>;
  @ViewChild('agGrid13', { static: true }) agGrid13: TemplateRef<any>;
  @ViewChild('agGrid14', { static: true }) agGrid14: TemplateRef<any>;
  @ViewChild('agGrid15', { static: true }) agGrid15: TemplateRef<any>;
  @ViewChild('agGrid16', { static: true }) agGrid16: TemplateRef<any>;
  @ViewChild('agGrid17', { static: true }) agGrid17: TemplateRef<any>;
  @ViewChild('agGrid18', { static: true }) agGrid18: TemplateRef<any>;
  @ViewChild('agGrid19', { static: true }) agGrid19: TemplateRef<any>;
  @ViewChild('uniAgGrid', { static: true }) uniAgGrid: TemplateRef<any>;
  
  // @ViewChild('chartId7', { static: true }) chartId7: TemplateRef<any>;
  // @ViewChild('myTemplateRef') myTemplate; 

  ngOnInit() {
    if (sessionStorage.getItem('currentUser') == null) {
      this.reportType = { paramName: 'civilian', paramValue: '' }
    } else if (JSON.parse(sessionStorage.getItem('currentUser')).paramName === 'STLU') {
      this.reportType = { paramName: JSON.parse(sessionStorage.getItem('currentUser')).paramName, paramValue: JSON.parse(sessionStorage.getItem('currentUser')).paramValue }
    } else {
      this.reportType = { paramName: 'civilian', paramValue: '' }
    }
    this.loadstaticReportData(this.reportType);
    this.ngxLoader.start();
  }


  public pieChartOptions: ChartOptions = {
    responsive: true,
  };
  public pieChartLabels: Label[];
  public pieChartData: SingleDataSet;
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];

  openXl(longContents) {
    if (longContents == 2) {
      this.modalService.open(this.longContent, { size: 'xl' });
    } else if (longContents == 3) {
      this.modalService.open(this.agGrid3, { size: 'xl' });
    } else if (longContents == 1) {
      this.modalService.open(this.agGrid1, { size: 'xl' });
    }else if(longContents == 4){
      this.modalService.open(this.agGrid4, { size: 'xl' });
    }else if(longContents == 5){ //   PGI RAW VALUES
      this.modalService.open(this.agGrid5, { size: 'xl' });
    }else if(longContents == 6){
      this.modalService.open(this.agGrid6, { size: 'xl' });    
    }else if(longContents == 7){
      this.modalService.open(this.agGrid7, { size: 'xl' });  
    }else if(longContents == 8){
      this.modalService.open(this.agGrid8, { size: 'xl' });  
    }else if(longContents == 9){
      this.modalRef= this.modalService.open(this.agGrid9, { size: 'xl' });  
      this.showGrid=false;
    }else if(longContents == 10){
      this.modalService.open(this.agGrid10, { size: 'xl' });
      this.showGrid=false;
    }else if(longContents == 11){
      this.modalService.open(this.agGrid11, { size: 'xl' });  
      this.showGrid=false;
    }else if(longContents == 12){
      this.modalService.open(this.agGrid12, { size: 'xl' });  
      this.showGrid=false;
    }else if(longContents == 13){
      this.modalService.open(this.agGrid13, { size: 'xl' });  
      this.showGrid=false;
    }else if(longContents == 14){
      this.modalService.open(this.agGrid14, { size: 'xl' });  
      this.showGrid=false;
    }else if(longContents == 15){
      this.modalService.open(this.agGrid15, { size: 'xl' });  
      this.showGrid=false;
    }else if(longContents == 16){
      this.modalService.open(this.agGrid16, { size: 'xl' });  
      this.showGrid=false;
    }else if(longContents == 17){
      this.modalService.open(this.agGrid17, { size: 'xl' });  
      this.showGrid=false;
    }else if(longContents == 18){
      this.modalService.open(this.agGrid18, { size: 'xl' });  
      this.showGrid=false;
    }else if(longContents == 19){
      this.modalService.open(this.agGrid19, { size: 'xl' });  
      this.showGrid=false;
    }else if(longContents > 19){
      this.modalService.open(this.uniAgGrid, { size: 'xl' });  
      this.showGrid=false;
      
    }
    this.getMasterData('GET_STATE', '');
  }

  openPieXl(longPieContents) {
    if (longPieContents === 1) {
      this.modalService.open(this.chartId1, { size: 'xl' });
    } else if ( longPieContents === 4) {
      this.modalService.open(this.chartId4, { size: 'xl' });
    }else if(longPieContents === 6){
      this.modalService.open(this.chartId6, { size: 'xl' });
      // Highcharts.chart('noSchoolChartContainer', this.noSchoolChartOption);
    }else if(longPieContents === 7){
      this.modalService.open(this.chartId7, { size: 'xl' });
    } else {
      let labels = ['Minor Repair', 'Major Repair', 'Good Condition'];
      let values = [];
      let index = 0;
      labels[index] = 'Week ';
      values[index] = '40';
      this.modalService.open(this.longPieContent, { size: 'xl' });
      this.pieChartLabels = labels;
      this.pieChartData = values;
    }
    this.getMasterData('GET_STATE', '');
  }

  getData(event) {
    let target = event.target || event.srcElement || event.currentTarget;
    let idAttr = target.attributes.id;
  }

  changeData(event) {
    this.filterValue = event.target.value;
  }

  checkVisibility(checkValue) {
    for (var i = 0; i < this.staticValues.length; i++) {
      if (this.staticValues[i].id == checkValue) {
        return this.rowCheck = true;
      }
    }
  }

  loadstaticReportData(reportTypes) {
    this.reportService.getStaticReportMaster(reportTypes).subscribe(res => {
      this.staticReportValues = res;
      this.filterReportCount=res.length;
    },
      error => {
        alert('get error in loadstaticReportData--->');
      })
  }
  paramName: String;
  paramValue: String;
  schemaName:String;
  getTabularData(dataObj, dependencyValue, isDependency) {
// alert("tabular data")
  if(isDependency !="Y" && dataObj==6){
    this.staticReportDependency={"year":"2018-19","state":"All"}
    dependencyValue=JSON.stringify(this.staticReportDependency);
  }else if(isDependency !="Y" && dataObj==7){
    this.staticReportDependency={"year":"2018-19","state":"All"}
    dependencyValue=JSON.stringify(this.staticReportDependency);
  }
    // JSON.parse(sessionStorage.getItem('currentUser'))
    if (JSON.parse(sessionStorage.getItem('currentUser')) == null) {
      this.paramName = "civilian";
      this.paramValue = "";
      this.schemaName="national";
    }else{
      this.paramName = JSON.parse(sessionStorage.getItem('currentUser')).paramName;
      this.paramValue = JSON.parse(sessionStorage.getItem('currentUser')).paramValue;
      this.schemaName=JSON.parse(sessionStorage.getItem('currentUser')).schema_name;
    }
    this.conditionObj = {
      mapId: dataObj,
      dependencyValue: dependencyValue,
      isDependency: isDependency,
      paramName:this.paramName ,
      paramValue: this.paramValue,
      schemaName:this.schemaName
    }

    this.reportCode="R"+dataObj;
    // alert(JSON.stringify(this.conditionObj))
    //  this.destroyDataTable();
    // this.Indaidata=[];
    // alert(JSON.stringify(this.conditionObj));
    // this.ngxLoader.start();
    // this.universalAgGridColumnDefs=[];
    this.reportService.getTabularData(this.conditionObj).subscribe(res => {
      // alert(JSON.stringify(res));
      console.log(JSON.stringify(res));

      // for(let i=0;i<JSON.parse(JSON.stringify(res.fileData)).length;i++){
      //   alert(JSON.stringify(JSON.stringify(res.fileData[i])));
      // }

      this.listColumeNames = res.columnName;
      this.columnValues = res.rowValue;
      this.rowData = res.rowValue;
     
      // alert("rowData-->"+JSON.stringify(this.rowData));
      // alert($(".modal-xl").width());
      // alert(this.listColumeNames.length);
      // alert(this.listColumeNames)
      this.defaultColDef = {
        width: $(".modal-xl").width() / (this.listColumeNames.length),
        sortable: true,
        // resizable: true
      };

      if (dataObj == 1) {
        //  alert($(window).width()/(this.listColumeNames.length))

      } else if (dataObj == 2) {

      } else if(dataObj == 6){
       for(let i=0;i<res.rowValue.length;i++){
        this.mapArray=[];
        this.Indaidata[i]={"hc-key":res.rowValue[i].state_name.toLowerCase().replace("&","and"),"value":res.rowValue[i].count};
       }
       Highcharts.mapChart('indaiImageContainer',this.indiaGraphoption).series[0].setData(this.Indaidata,true);;
      }else if(dataObj == 7){
              
              for(let i=0;i<res.rowValue.length;i++){
                this.category1 = +res.rowValue[i].a1;
               }
              //  const a={headerName:res.columnView[i],field:res.columnName[i]}
              // this.TableHeaders={headerName:res.columnView[i],field:res.columnName[i]}
              if(isDependency !="Y"){
              this.universalAgGridColumnDefs=[{headerName:"State Name",field:"state_name", rowGroup: true, filter:"agSetColumnFilter",
              hide: true},
              {headerName:"District Name",field:"district_name"},
              // {headerName:"Block Name",field:"block_name"},
              {headerName:"Primary only with grades 1 to 5",field:"1",aggFunc: "sum",hide: true},
              {headerName:"Upper Primary with grades 1 to 8",field:"2",aggFunc: "sum"},
              {headerName:"Higher Secondary with grades 1 to 12",field:"3",aggFunc: "sum"},
              {headerName:"Upper Primary only with grades 6 to 8",field:"4",aggFunc: "sum"},
              {headerName:"Higher Secondary with grades 6 to 12",field:"5",aggFunc: "sum"},
              {headerName:"Secondary/Sr. Sec. with grades 1 to 10",field:"6",aggFunc: "sum"},
              {headerName:"Secondary/Sr. Sec. with grades 6 to 10",field:"7",aggFunc: "sum"},
              {headerName:"Secondary/Sr. Sec. only with grades 9 & 10",field:"8",aggFunc: "sum"},
              {headerName:"Higher Secondary with grades 9 to 12",field:"10",aggFunc: "sum"},
              {headerName:"Hr. Sec. or Jr. College only with grades",field:"11",aggFunc: "sum"}
            ];

           
            // this.rowData.push({"1":"","2":"","3":"","4":"","5":"","6":"","7":"","8":"","10":"","11":"","state_name":"total"})
          }else{
            this.universalAgGridColumnDefs=[{headerName:"District Name",field:"district_name",rowGroup: true, filter:"agSetColumnFilter",hide: true},
            {headerName:"Block Name",field:"block_name"},
            {headerName:"Primary only with grades 1 to 5",field:"1",aggFunc: "sum"},
              {headerName:"Upper Primary with grades 1 to 8",field:"2",aggFunc: "sum"},
              {headerName:"Higher Secondary with grades 1 to 12",field:"3",aggFunc: "sum"},
              {headerName:"Upper Primary only with grades 6 to 8",field:"4",aggFunc: "sum"},
              {headerName:"Higher Secondary with grades 6 to 12",field:"5",aggFunc: "sum"},
              {headerName:"Secondary/Sr. Sec. with grades 1 to 10",field:"6",aggFunc: "sum"},
              {headerName:"Secondary/Sr. Sec. with grades 6 to 10",field:"7",aggFunc: "sum"},
              {headerName:"Secondary/Sr. Sec. only with grades 9 & 10",field:"8",aggFunc: "sum"},
              {headerName:"Higher Secondary with grades 9 to 12",field:"10",aggFunc: "sum"},
              {headerName:"Hr. Sec. or Jr. College only with grades",field:"11",aggFunc: "sum"}
          ];
          // }
              // this.universalAgGridColumnDefs.push("{headerName:"+res.columnView[i], "field:"+res.columnName[i]+"}");
             }
// alert(JSON.stringify(this.universalAgGridColumnDefs));     
// alert(JSON.stringify(this.rowData)); 
      }else if(dataObj == 8){
        this.universalAgGridColumnDefs=[{headerName:"School Management",field:"sch_mgmt_name"},
        {headerName:"Primary Boys",field:"primary_b"},
        {headerName:"Primary Girl",field:"primary_g"},
        {headerName:"Total Primary",field:"primary_total"},
        {headerName:"Upper Primary Boys",field:"upper_primary_b"},
        {headerName:"Upper Primary Girls",field:"upper_primary_g"},
        {headerName:"Total Upper Primary",field:"upper_primary_total"},
        {headerName:"Secondary Boys",field:"secondary_b"},
        {headerName:"Secondary Girls",field:"secondary_g"},
        {headerName:"Total Secondary",field:"secondary_total"},
        {headerName:"Higher Secondary Boys",field:"higher_secondary_b"},
  {headerName:"Higher Secondary Girls",field:"higher_secondary_g"},
        {headerName:"Total Higher Secondary",field:"higher_secondary_total"},
        {headerName:"School Management Id",field:"sch_mgmt_id"}
      ];
      }else if(dataObj == 9){
        this.defaultColDef = {
          width: $(".modal-xl").width() /6,
          sortable: true,
        };
        this.universalAgGridColumnDefs=[{headerName:"No of School",field:"no_of_school"},
        {headerName:"Location Name",field:"loc_name",filter:'agTextColumnFilter'},
        {headerName:"School Management Name",field:"sch_mgmt_name",filter:'agTextColumnFilter'},
        {headerName:"Min  Management Name",field:"min_mgmt_name",filter:'agTextColumnFilter'},
        {headerName:"Category Name",field:"category_name",filter:'agTextColumnFilter'},
        {headerName:"School Type",field:"school_type",filter:'agTextColumnFilter'}      
      ];
      // alert("display")
      this.showGrid=true;
      }else if(dataObj == 10){
        this.universalAgGridColumnDefs=[{headerName:"No of School",field:"no_of_school"},
        {headerName:"Location Name",field:"loc_name",filter:'agTextColumnFilter'},
        {headerName:"School Management Name",field:"sch_mgmt_name",filter:'agTextColumnFilter'},
        {headerName:"Min  Management Name",field:"min_mgmt_name",filter:'agTextColumnFilter'},
        {headerName:"Category Name",field:"category_name",filter:'agTextColumnFilter'},
        {headerName:"School Type",field:"school_type",filter:'agTextColumnFilter'},
        {headerName:"State Name",field:"state_name",filter:'agTextColumnFilter'}       
      ];
      this.showGrid=true;
      }else if(dataObj == 11){
        this.universalAgGridColumnDefs=[{headerName:"No of School",field:"no_of_school"},
        // {headerName:"Location Name",field:"loc_name"},
        {headerName:"Total Student",field:"total_student"},
        {headerName:"Total Boys",field:"total_boys"},
        {headerName:"Total Girls",field:"total_girls"},
        {headerName:"School Type",field:"school_type",filter:'agTextColumnFilter'},
        {headerName:"Location Name",field:"loc_name",filter:'agTextColumnFilter'},  
        {headerName:"School Management Name",field:"sch_mgmt_name",filter:'agTextColumnFilter'}, 
        {headerName:"Min  Management Name",field:"min_mgmt_name",filter:'agTextColumnFilter'},  
        {headerName:"Category Name",field:"category_name",filter:'agTextColumnFilter'}       
      ];
      this.showGrid=true;
      }else if(dataObj == 12){
        this.universalAgGridColumnDefs=[{headerName:"No of School",field:"no_of_school"},
        // {headerName:"Location Name",field:"loc_name"},
        {headerName:"Total Student",field:"total_student"},
        {headerName:"No of Teacher",field:"number_of_teacher"},
        {headerName:"School Type",field:"school_type",filter:'agTextColumnFilter'},
        {headerName:"Location Name",field:"loc_name",filter:'agTextColumnFilter'},  
        {headerName:"School Management Name",field:"sch_mgmt_name",filter:'agTextColumnFilter'}, 
        {headerName:"Min  Management Name",field:"min_mgmt_name",filter:'agTextColumnFilter'},  
        {headerName:"Category Name",field:"category_name",filter:'agTextColumnFilter'}       
      ];
      this.showGrid=true;
      }else if(dataObj == 13){
        this.universalAgGridColumnDefs=[{headerName:"No of School",field:"no_of_school"},
        {headerName:"Total Student",field:"total_student"},
        {headerName:"Total Boys",field:"total_boys"},
        {headerName:"Total Girls",field:"total_girls"},
        {headerName:"State Name",field:"state_name", filter: 'agSetColumnFilter', filterParams: {
          cellHeight: 20,
          values: this.stateName(),
          debounceMs: 1000,
        },},
        {headerName:"School Type",field:"school_type",filter:'agTextColumnFilter'},
        {headerName:"Location Name",field:"loc_name",filter:'agTextColumnFilter'},  
        {headerName:"School Management Name",field:"sch_mgmt_name",filter:'agTextColumnFilter'}, 
        {headerName:"Min  Management Name",field:"min_mgmt_name",filter:'agTextColumnFilter'},  
        {headerName:"Category Name",field:"category_name",filter:'agTextColumnFilter'}       
      ];
      this.showGrid=true;
      }else if(dataObj == 14){
        this.universalAgGridColumnDefs=[{headerName:"No of School",field:"no_of_school"},
        {headerName:"Total Student",field:"total_student"},
        {headerName:"Number of Teacher",field:"number_of_teacher"},
        {headerName:"State Name",field:"state_name", filter: 'agSetColumnFilter', filterParams: {
          cellHeight: 20,
          values: this.stateName(),
          debounceMs: 1000,
        },},
        {headerName:"School Type",field:"school_type",filter:'agTextColumnFilter'},
        {headerName:"Location Name",field:"loc_name",filter:'agTextColumnFilter'},  
        {headerName:"School Management Name",field:"sch_mgmt_name",filter:'agTextColumnFilter'}, 
        {headerName:"Min  Management Name",field:"min_mgmt_name",filter:'agTextColumnFilter'},  
        {headerName:"Category Name",field:"category_name",filter:'agTextColumnFilter'}       
      ];
      this.showGrid=true;
      }else if(dataObj == 15){
        this.universalAgGridColumnDefs=[{headerName:"No of School",field:"school_count"},
        {headerName:"General",field:"gen"},
        {headerName:"SC",field:"sc"},
        {headerName:"ST",field:"st"},
        {headerName:"OBC",field:"obc"},
        {headerName:"ORC",field:"orc"},  
        {headerName:"Other",field:"othre"}, 
        {headerName:"Min  Management Name",field:"min_mgmt_name",filter:'agTextColumnFilter'},  
        {headerName:"Category Name",field:"category_name",filter:'agTextColumnFilter'}       
      ];
      this.showGrid=true;
      }else if(dataObj == 16){
        this.universalAgGridColumnDefs=[{headerName:"Grade",field:"grade"},
        {headerName:"Primary only with grades 1 to 5",field:"cat1", width:250},
        {headerName:"Upper Primary with grades 1 to 8",field:"cat2", width:250},
        {headerName:"Higher Secondary with grades 1 to 12",field:"cat3", width:250},
        {headerName:"Upper Primary only with grades 6 to 8",field:"cat4", width:250},
        {headerName:"Higher Secondary with grades 6 to 12",field:"cat5", width:250},  
        {headerName:"Secondary/Sr. Sec. with grades 1 to 10",field:"cat6", width:250}, 
        {headerName:"Secondary/Sr. Sec. with grades 6 to 10",field:"cat7", width:250},  
        {headerName:"Secondary/Sr. Sec. only with grades 9 & 10",field:"cat8", width:250},
        {headerName:"Higher Secondary with grades 9 to 12",field:"cat10", width:250},
        {headerName:"Hr. Sec/Jr College only with grades 11 & 12",field:"cat11", width:250}       
      ];
        for(let i=0;i< this.rowData.length;i++){
          // alert(this.rowData[i].json_object_agg[1])
          this.rowData[i]={"grade":this.rowData[i].grade,"cat1":this.rowData[i].json_object_agg[1],"cat2":this.rowData[i].json_object_agg[2]
          ,"cat3":this.rowData[i].json_object_agg[3]
          ,"cat4":this.rowData[i].json_object_agg[4]
            ,"cat5":this.rowData[i].json_object_agg[5]
            ,"cat6":this.rowData[i].json_object_agg[6]
            ,"cat7":this.rowData[i].json_object_agg[7]
            ,"cat8":this.rowData[i].json_object_agg[8]
            ,"cat10":this.rowData[i].json_object_agg[10]
            ,"cat11":this.rowData[i].json_object_agg[11]
        }
        }
        this.showGrid=true;
        // alert("final roeData--->"+this.rowData)
      }else if(dataObj == 17){
        this.universalAgGridColumnDefs=[{headerName:"Diploma or Certificate in Basic Teacher Training",field:"Diploma or Certificate in Basic Teacher Training"},
        {headerName:"B.El.Ed",field:"B_El_Ed"},
        {headerName:"B.Ed",field:"B_Ed"},
        {headerName:"M.Ed",field:"M_Ed"},
        {headerName:"Other",field:"Other"},
        {headerName:"Diploma or Degree Special Education",field:"Diploma or Degree Special Education"},  
        {headerName:"PursuingRelevant Prof Course",field:"PursuingRelevant Prof Course"}, 
        {headerName:"None",field:"None"}
             
      ];
      this.showGrid=true;
      }else if(dataObj == 18){
        this.universalAgGridColumnDefs=[{headerName:"No. of School",field:"school_count"},
        {headerName:"No. of Male Teacher",field:"number_of_teacher_male"},
        {headerName:"No. of Female Teacher",field:"number_of_teacher_female"},
        {headerName:"Min Management Name",field:"min_mgmt_name",filter:'agTextColumnFilter'},
        {headerName:"Category Name",field:"category_name",filter:'agTextColumnFilter'}      
      ];
      this.showGrid=true;
      }else if(dataObj == 19){
        this.universalAgGridColumnDefs=[{headerName:"Grade",field:"grade"},
        {headerName:"Primary only with grades 1 to 5",field:"_1", filter:'agNumberColumnFilter', width:250},
        {headerName:"Upper Primary with grades 1 to 8",field:"_2", filter:'agNumberColumnFilter', width:250},
        {headerName:"Higher Secondary with grades 1 to 12",field:"_3", filter:'agNumberColumnFilter', width:250},
        {headerName:"Upper Primary only with grades 6 to 8",field:"_4", filter:'agNumberColumnFilter', width:250},
        {headerName:"Higher Secondary with grades 6 to 12",field:"_5", filter:'agNumberColumnFilter', width:250},  
        {headerName:"Secondary/Sr. Sec. with grades 1 to 10",field:"_6", filter:'agNumberColumnFilter', width:250}, 
        {headerName:"Secondary/Sr. Sec. with grades 6 to 10",field:"_7", filter:'agNumberColumnFilter', width:250},  
        {headerName:"Secondary/Sr. Sec. only with grades 9 & 10",field:"_8", filter:'agNumberColumnFilter', width:250},
        {headerName:"Higher Secondary with grades 9 to 12",field:"_10", filter:'agNumberColumnFilter', width:250},
        {headerName:"Hr. Sec/Jr College only with grades 11 & 12",field:"_11", filter:'agNumberColumnFilter', width:250}       
      ];
        this.showGrid=true;
      }else if(dataObj == 20){
        this.uniHeader="National Dropout of students";
        this.universalAgGridColumnDefs=[{headerName: "class I(PR*-Promotion Rate, DR*- Drop Rate, RR*-Repeation Rate)",children: [{headerName: "PR(%)", field: "pr_1",width:200},{headerName: "DR(%)", field: "dr1",width:100},{headerName: "RR(%)", field: "rr1",width:100}]},
        {headerName: "class II",children: [{headerName: "PR%", field: "pr_2",width:70},{headerName: "DR%", field: "dr2",width:70},{headerName: "RR%", field: "rr2",width:70}]},
        {headerName: "class III",children: [{headerName: "PR%", field: "pr_3",width:70},{headerName: "DR%", field: "dr3",width:70},{headerName: "RR%", field: "rr3",width:70}]},
        {headerName: "class IV",children: [{headerName: "PR%", field: "pr_4",width:70},{headerName: "DR%", field: "dr4",width:70},{headerName: "RR%", field: "rr4",width:70}]},
        {headerName: "class V",children: [{headerName: "PR%", field: "pr_5",width:70},{headerName: "DR%", field: "dr5",width:70},{headerName: "RR%", field: "rr5",width:70}]}, 
        {headerName: "class VI",children: [{headerName: "PR%", field: "pr_6",width:70},{headerName: "DR%", field: "dr6",width:70},{headerName: "RR%", field: "rr6",width:70}]},
        {headerName: "class VII",children: [{headerName: "PR%", field: "pr_7",width:70},{headerName: "DR%", field: "dr7",width:70},{headerName: "RR%", field: "rr7",width:70}]},
        {headerName: "class VIII",children: [{headerName: "PR%", field: "pr_8",width:70},{headerName: "DR%", field: "dr8",width:70},{headerName: "RR%", field: "rr8",width:70}]},
        {headerName: "class IX",children: [{headerName: "PR%", field: "pr_9",width:70},{headerName: "DR%", field: "dr9",width:70},{headerName: "RR%", field: "rr9",width:70}]},
        {headerName: "class X",children: [{headerName: "PR%", field: "pr_10",width:70},{headerName: "DR%", field: "dr10",width:70},{headerName: "RR%", field: "rr10",width:70}]},
      ];
        this.showGrid=true;
      }else if(dataObj == 21){
        this.uniHeader="National Dropout Same School";
        this.universalAgGridColumnDefs=[{headerName: "class I(PR*-Promotion Rate, DR*- Drop Rate, RR*-Repeation Rate)",children: [{headerName: "PR(%)", field: "pr_1",width:200},{headerName: "DR(%)", field: "dr1",width:100},{headerName: "RR(%)", field: "rr1",width:100}]},
        {headerName: "class II",children: [{headerName: "PR%", field: "pr_2",width:70},{headerName: "DR%", field: "dr2",width:70},{headerName: "RR%", field: "rr2",width:70}]},
        {headerName: "class III",children: [{headerName: "PR%", field: "pr_3",width:70},{headerName: "DR%", field: "dr3",width:70},{headerName: "RR%", field: "rr3",width:70}]},
        {headerName: "class IV",children: [{headerName: "PR%", field: "pr_4",width:70},{headerName: "DR%", field: "dr4",width:70},{headerName: "RR%", field: "rr4",width:70}]},
        {headerName: "class V",children: [{headerName: "PR%", field: "pr_5",width:70},{headerName: "DR%", field: "dr5",width:70},{headerName: "RR%", field: "rr5",width:70}]}, 
        {headerName: "class VI",children: [{headerName: "PR%", field: "pr_6",width:70},{headerName: "DR%", field: "dr6",width:70},{headerName: "RR%", field: "rr6",width:70}]},
        {headerName: "class VII",children: [{headerName: "PR%", field: "pr_7",width:70},{headerName: "DR%", field: "dr7",width:70},{headerName: "RR%", field: "rr7",width:70}]},
        {headerName: "class VIII",children: [{headerName: "PR%", field: "pr_8",width:70},{headerName: "DR%", field: "dr8",width:70},{headerName: "RR%", field: "rr8",width:70}]},
        {headerName: "class IX",children: [{headerName: "PR%", field: "pr_9",width:70},{headerName: "DR%", field: "dr9",width:70},{headerName: "RR%", field: "rr9",width:70}]},
        {headerName: "class X",children: [{headerName: "PR%", field: "pr_10",width:70},{headerName: "DR%", field: "dr10",width:70},{headerName: "RR%", field: "rr10",width:70}]},
      ];                                                                                  
        this.showGrid=true;
      }else if(dataObj == 22){                                                                                                              
        this.uniHeader="State Dropout";
        this.universalAgGridColumnDefs=[
          {headerName: "StateName", field: "state_name",width:300, filter: 'agSetColumnFilter', filterParams: {
            cellHeight: 20,
            values: this.stateName(),
            debounceMs: 1000,
          },},  
        {headerName: "class I(PR*-Promotion Rate, DR*- Drop Rate, RR*-Repeation Rate)",children: [{headerName: "PR(%)", field: "pr_1",width:200},{headerName: "DR(%)", field: "dr1",width:100},{headerName: "RR(%)", field: "rr1",width:100}]},
        {headerName: "class II",children: [{headerName: "PR%", field: "pr_2",width:70},{headerName: "DR%", field: "dr2",width:70},{headerName: "RR%", field: "rr2",width:70}]},
        {headerName: "class III",children: [{headerName: "PR%", field: "pr_3",width:70},{headerName: "DR%", field: "dr3",width:70},{headerName: "RR%", field: "rr3",width:70}]},
        {headerName: "class IV",children: [{headerName: "PR%", field: "pr_4",width:70},{headerName: "DR%", field: "dr4",width:70},{headerName: "RR%", field: "rr4",width:70}]},
        {headerName: "class V",children: [{headerName: "PR%", field: "pr_5",width:70},{headerName: "DR%", field: "dr5",width:70},{headerName: "RR%", field: "rr5",width:70}]}, 
        {headerName: "class VI",children: [{headerName: "PR%", field: "pr_6",width:70},{headerName: "DR%", field: "dr6",width:70},{headerName: "RR%", field: "rr6",width:70}]},
        {headerName: "class VII",children: [{headerName: "PR%", field: "pr_7",width:70},{headerName: "DR%", field: "dr7",width:70},{headerName: "RR%", field: "rr7",width:70}]},
        {headerName: "class VIII",children: [{headerName: "PR%", field: "pr_8",width:70},{headerName: "DR%", field: "dr8",width:70},{headerName: "RR%", field: "rr8",width:70}]},
        {headerName: "class IX",children: [{headerName: "PR%", field: "pr_9",width:70},{headerName: "DR%", field: "dr9",width:70},{headerName: "RR%", field: "rr9",width:70}]},
        {headerName: "class X",children: [{headerName: "PR%", field: "pr_10",width:70},{headerName: "DR%", field: "dr10",width:70},{headerName: "RR%", field: "rr10",width:70}]},
      
      ];
        this.showGrid=true;
      }else if(dataObj == 23){
        this.uniHeader="State Dropout Same School";
        this.universalAgGridColumnDefs=[
          {headerName: "StateName", field: "state_name",width:300, filter: 'agSetColumnFilter', filterParams: {
            cellHeight: 20,
            values: this.stateName(),
            debounceMs: 1000,
          },},
          {headerName: "class I(PR*-Promotion Rate, DR*- Drop Rate, RR*-Repeation Rate)",children: [{headerName: "PR(%)", field: "pr_1",width:200},{headerName: "DR(%)", field: "dr1",width:100},{headerName: "RR(%)", field: "rr1",width:100}]},
        {headerName: "class II",children: [{headerName: "PR%", field: "pr_2",width:70},{headerName: "DR%", field: "dr2",width:70},{headerName: "RR%", field: "rr2",width:70}]},
        {headerName: "class III",children: [{headerName: "PR%", field: "pr_3",width:70},{headerName: "DR%", field: "dr3",width:70},{headerName: "RR%", field: "rr3",width:70}]},
        {headerName: "class IV",children: [{headerName: "PR%", field: "pr_4",width:70},{headerName: "DR%", field: "dr4",width:70},{headerName: "RR%", field: "rr4",width:70}]},
        {headerName: "class V",children: [{headerName: "PR%", field: "pr_5",width:70},{headerName: "DR%", field: "dr5",width:70},{headerName: "RR%", field: "rr5",width:70}]}, 
        {headerName: "class VI",children: [{headerName: "PR%", field: "pr_6",width:70},{headerName: "DR%", field: "dr6",width:70},{headerName: "RR%", field: "rr6",width:70}]},
        {headerName: "class VII",children: [{headerName: "PR%", field: "pr_7",width:70},{headerName: "DR%", field: "dr7",width:70},{headerName: "RR%", field: "rr7",width:70}]},
        {headerName: "class VIII",children: [{headerName: "PR%", field: "pr_8",width:70},{headerName: "DR%", field: "dr8",width:70},{headerName: "RR%", field: "rr8",width:70}]},
        {headerName: "class IX",children: [{headerName: "PR%", field: "pr_9",width:70},{headerName: "DR%", field: "dr9",width:70},{headerName: "RR%", field: "rr9",width:70}]},
        {headerName: "class X",children: [{headerName: "PR%", field: "pr_10",width:70},{headerName: "DR%", field: "dr10",width:70},{headerName: "RR%", field: "rr10",width:70}]},
     
      ];
        this.showGrid=true;
      }else if(dataObj == 24){
        this.uniHeader="District Dropout";
        this.universalAgGridColumnDefs=[
          {headerName: "District Name", field: "district_name",width:300},
          {headerName: "StateName", field: "state_name",width:300, filter: 'agSetColumnFilter', filterParams: {
            cellHeight: 20,
            values: this.stateName(),
            debounceMs: 1000,
          },
        },
          {headerName: "class I(PR*-Promotion Rate, DR*- Drop Rate, RR*-Repeation Rate)",children: [{headerName: "PR(%)", field: "pr_1",width:200},{headerName: "DR(%)", field: "dr1",width:100},{headerName: "RR(%)", field: "rr1",width:100}]},
        {headerName: "class II",children: [{headerName: "PR%", field: "pr_2",width:70},{headerName: "DR%", field: "dr2",width:70},{headerName: "RR%", field: "rr2",width:70}]},
        {headerName: "class III",children: [{headerName: "PR%", field: "pr_3",width:70},{headerName: "DR%", field: "dr3",width:70},{headerName: "RR%", field: "rr3",width:70}]},
        {headerName: "class IV",children: [{headerName: "PR%", field: "pr_4",width:70},{headerName: "DR%", field: "dr4",width:70},{headerName: "RR%", field: "rr4",width:70}]},
        {headerName: "class V",children: [{headerName: "PR%", field: "pr_5",width:70},{headerName: "DR%", field: "dr5",width:70},{headerName: "RR%", field: "rr5",width:70}]}, 
        {headerName: "class VI",children: [{headerName: "PR%", field: "pr_6",width:70},{headerName: "DR%", field: "dr6",width:70},{headerName: "RR%", field: "rr6",width:70}]},
        {headerName: "class VII",children: [{headerName: "PR%", field: "pr_7",width:70},{headerName: "DR%", field: "dr7",width:70},{headerName: "RR%", field: "rr7",width:70}]},
        {headerName: "class VIII",children: [{headerName: "PR%", field: "pr_8",width:70},{headerName: "DR%", field: "dr8",width:70},{headerName: "RR%", field: "rr8",width:70}]},
        {headerName: "class IX",children: [{headerName: "PR%", field: "pr_9",width:70},{headerName: "DR%", field: "dr9",width:70},{headerName: "RR%", field: "rr9",width:70}]},
        {headerName: "class X",children: [{headerName: "PR%", field: "pr_10",width:70},{headerName: "DR%", field: "dr10",width:70},{headerName: "RR%", field: "rr10",width:70}]},
      
        
      ];
        this.showGrid=true;
      }else if(dataObj == 25){
        this.uniHeader="District Dropout Same School";
        this.universalAgGridColumnDefs=[
          {headerName: "District Name", field: "district_name",width:300},
          {headerName: "StateName", field: "state_name",width:300, filter: 'agSetColumnFilter', filterParams: {
            cellHeight: 20,
            values: this.stateName(),
            debounceMs: 1000,
          }}, 
        {headerName: "class I(PR*-Promotion Rate, DR*- Drop Rate, RR*-Repeation Rate)",children: [{headerName: "PR(%)", field: "pr_1",width:200},{headerName: "DR(%)", field: "dr1",width:100},{headerName: "RR(%)", field: "rr1",width:100}]},
        {headerName: "class II",children: [{headerName: "PR%", field: "pr_2",width:70},{headerName: "DR%", field: "dr2",width:70},{headerName: "RR%", field: "rr2",width:70}]},
        {headerName: "class III",children: [{headerName: "PR%", field: "pr_3",width:70},{headerName: "DR%", field: "dr3",width:70},{headerName: "RR%", field: "rr3",width:70}]},
        {headerName: "class IV",children: [{headerName: "PR%", field: "pr_4",width:70},{headerName: "DR%", field: "dr4",width:70},{headerName: "RR%", field: "rr4",width:70}]},
        {headerName: "class V",children: [{headerName: "PR%", field: "pr_5",width:70},{headerName: "DR%", field: "dr5",width:70},{headerName: "RR%", field: "rr5",width:70}]}, 
        {headerName: "class VI",children: [{headerName: "PR%", field: "pr_6",width:70},{headerName: "DR%", field: "dr6",width:70},{headerName: "RR%", field: "rr6",width:70}]},
        {headerName: "class VII",children: [{headerName: "PR%", field: "pr_7",width:70},{headerName: "DR%", field: "dr7",width:70},{headerName: "RR%", field: "rr7",width:70}]},
        {headerName: "class VIII",children: [{headerName: "PR%", field: "pr_8",width:70},{headerName: "DR%", field: "dr8",width:70},{headerName: "RR%", field: "rr8",width:70}]},
        {headerName: "class IX",children: [{headerName: "PR%", field: "pr_9",width:70},{headerName: "DR%", field: "dr9",width:70},{headerName: "RR%", field: "rr9",width:70}]},
        {headerName: "class X",children: [{headerName: "PR%", field: "pr_10",width:70},{headerName: "DR%", field: "dr10",width:70},{headerName: "RR%", field: "rr10",width:70}]}
   
      ];
        this.showGrid=true;
      }else if(dataObj == 26){
        this.uniHeader="Status Of School Over Time";
        this.universalAgGridColumnDefs=[{headerName:"No. of School",field:"no_of_school"},
        {headerName:"2015-16",sortable: true,field:"status_15_16", filter: 'agSetColumnFilter', cellRenderer: function(params) {
          if (params.value === "0") {
              return 'Operational(0)';
          } else if(params.value === "1") {
              return 'Closed(1)';
          }else if(params.value === "2") {
            return 'Merged(2)';
        }else if(params.value === "3") {
          return 'Sanctioned(3)';
      }else if(params.value === "4") {
        return 'DCF Not Found(4)';
    }else if(params.value === "9") {
      return 'Not Engaged(9)';
  }
      } },
        {headerName:"2016-17",sortable: true,field:"status_16_17", filter: 'agSetColumnFilter', cellRenderer: function(params) {
          if (params.value === "0") {
              return 'Operational(0)';
          } else if(params.value === "1") {
              return 'Closed(1)';
          }else if(params.value === "2") {
            return 'Merged(2)';
        }else if(params.value === "3") {
          return 'Sanctioned(3)';
      }else if(params.value === "4") {
        return 'DCF Not Found(4)';
    }else if(params.value === "9") {
      return 'Not Engaged(9)';
  }
      }},
        {headerName:"2017-18",sortable: true,field:"status_17_18", filter: 'agSetColumnFilter', cellRenderer: function(params) {
          if (params.value === "0") {
              return 'Operational(0)';
          } else if(params.value === "1") {
              return 'Closed(1)';
          }else if(params.value === "2") {
            return 'Merged(2)';
        }else if(params.value === "3") {
          return 'Sanctioned(3)';
      }else if(params.value === "4") {
        return 'DCF Not Found(4)';
    }else if(params.value === "9") {
      return 'Not Engaged(9)';
  }
      }},
        {headerName:"2018-19",sortable: true,field:"status_18_19", filter: 'agSetColumnFilter', cellRenderer: function(params) {
          if (params.value === "0") {
              return 'Operational(0)';
          } else if(params.value === "1") {
              return 'Closed(1)';
          }else if(params.value === "2") {
            return 'Merged(2)';
        }else if(params.value === "3") {
          return 'Sanctioned(3)';
      }else if(params.value === "4") {
        return 'DCF Not Found(4)';
    }else if(params.value === "9") {
      return 'Not Engaged(9)';
  }
      }}      
      ];
      this.showGrid=true;
      }else if(dataObj == 27){
        this.uniHeader="History Of School Establishment By Management";
        this.universalAgGridColumnDefs=[
          {headerName:"Year",field:"estd_year", filter:'agNumberColumnFilter', width:250},
          {headerName:"Govement School",field:"Govt", filter:'agNumberColumnFilter', width:250},
          {headerName:"Private School",field:"Pvt", filter:'agNumberColumnFilter', width:250},
          {headerName:"Other",field:"Other", filter:'agNumberColumnFilter', width:250},
          {headerName:"Cumulative Number of School",field:"cumulative_sum", filter:'agNumberColumnFilter', width:250}
      ];                                                                                  
        this.showGrid=true;
      }else if(dataObj == 28){
        this.uniHeader="Status Of School Building All";
        this.universalAgGridColumnDefs=[
          {headerName:"No Of School",field:"no_of_school", filter:'agNumberColumnFilter', width:250},
          {headerName:"Building Status Name",field:"bld_status_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Category Name",field:"category_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"School Management 2018-19",field:"sch_mgmt_18_19", filter:'agNumberColumnFilter', width:250},
          {headerName:"School Management Name",field:"sch_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Report Management Name",field:"report_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Location",field:"location_r_u", filter:'agNumberColumnFilter', width:250}
      ];                                                                                  
        this.showGrid=true;
      }else if(dataObj == 29){
        this.uniHeader="Status Of School Building State";
        this.universalAgGridColumnDefs=[
          {headerName:"No Of School",field:"no_of_school", filter:'agNumberColumnFilter', width:250},
          {headerName:"Building Status Name",field:"bld_status_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Category Name",field:"category_name", filter:'agNumberColumnFilter', width:250},
          // {headerName:"School Management 2018-19",field:"sch_mgmt_18_19", filter:'agNumberColumnFilter', width:250},
          {headerName:"School Management Name",field:"sch_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Report Management Name",field:"report_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Location",field:"location_r_u", filter:'agNumberColumnFilter', width:250},
          {headerName:"State Name",field:"state_name", filter:'agNumberColumnFilter', width:250}          
        ];                                                                                  
        this.showGrid=true;
      }else if(dataObj == 30){
        this.uniHeader="Status Of School Building District";
        this.universalAgGridColumnDefs=[
          {headerName:"No Of School",field:"no_of_school", filter:'agNumberColumnFilter', width:250},
          {headerName:"Building Status Name",field:"bld_status_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Category Name",field:"category_name", filter:'agNumberColumnFilter', width:250},
          // {headerName:"School Management 2018-19",field:"sch_mgmt_18_19", filter:'agNumberColumnFilter', width:250},
          {headerName:"School Management Name",field:"sch_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Report Management Name",field:"report_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Location",field:"location_r_u", filter:'agNumberColumnFilter', width:250},
          {headerName:"District Name",field:"district_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"State Name",field:"state_name", filter:'agNumberColumnFilter', width:250}                    
          
        ];                                                                                  
        this.showGrid=true;
      }else if(dataObj == 31){
        this.uniHeader="Status Of School Building Nation 2017-18";
        this.universalAgGridColumnDefs=[
          {headerName:"No Of School",field:"no_of_school", filter:'agNumberColumnFilter', width:250},
          {headerName:"Building Status Name",field:"bld_status_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Category Name",field:"category_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"School Management Name",field:"sch_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Report Management Name",field:"report_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Location",field:"location_r_u", filter:'agNumberColumnFilter', width:250}
        ];                                                                                  
        this.showGrid=true;
      }else if(dataObj == 32){
        this.uniHeader="Status Of School Building Nation 2016-17";
        
        this.universalAgGridColumnDefs=[
          {headerName:"No Of School",field:"no_of_school", filter:'agNumberColumnFilter', width:250},
          {headerName:"Building Status Name",field:"bld_status_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Category Name",field:"category_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"School Management Name",field:"sch_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Report Management Name",field:"report_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Location",field:"location_r_u", filter:'agNumberColumnFilter', width:250}
        ];                                                                                  
        this.showGrid=true;
      }else if(dataObj == 33){
        this.uniHeader="Status Of School Building State 2017-18";
        this.universalAgGridColumnDefs=[
          {headerName:"No Of School",field:"no_of_school", filter:'agNumberColumnFilter', width:250},
          {headerName:"Building Status Name",field:"bld_status_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Category Name",field:"category_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"School Management Name",field:"sch_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Report Management Name",field:"report_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Location",field:"location_r_u", filter:'agNumberColumnFilter', width:250},
          {headerName:"State",field:"state_name", filter:'agNumberColumnFilter', width:250}
        ];                                                                                  
        this.showGrid=true;
      }else if(dataObj == 34){
        this.uniHeader="Change Of Status School Building 1718_to_1819";
        this.universalAgGridColumnDefs=[
          {headerName:"No Of School",field:"no_of_school", filter:'agNumberColumnFilter', width:250},
          {headerName:"Building Status 17-18",field:"bld_status_17_18", filter:'agNumberColumnFilter', width:250},
          {headerName:"Building Status 18-19",field:"bld_status_18_19", filter:'agNumberColumnFilter', width:250},
          {headerName:"Report Management Name",field:"report_mgmt_name", filter:'agNumberColumnFilter', width:250},
        ];                                                                                  
        this.showGrid=true;
      }else if(dataObj == 35){
        this.uniHeader="All Type Boundary Wall All Year State";
        this.universalAgGridColumnDefs=[
          {headerName:"Academin year",field:"ac_year", filter:'agNumberColumnFilter', width:250},
          {headerName:"State Name",field:"state_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"No Boundary Wall",field:"No Boundary Wall", filter:'agNumberColumnFilter', width:250},
          {headerName:"Not Applicable",field:"Not Applicable", filter:'agNumberColumnFilter', width:250},
          {headerName:"Pucca",field:"Pucca", filter:'agNumberColumnFilter', width:250},
          {headerName:"Pucca but Broken",field:"Pucca but Broken", filter:'agNumberColumnFilter', width:250},
          {headerName:"Barbed Wire Fencing",field:"Barbed Wire Fencing", filter:'agNumberColumnFilter', width:250},
          {headerName:"Hedges",field:"Hedges", filter:'agNumberColumnFilter', width:250},
          {headerName:"Others",field:"Others", filter:'agNumberColumnFilter', width:250},
          {headerName:"Partial",field:"Partial", filter:'agNumberColumnFilter', width:250},
          {headerName:"Under Construction",field:"Under Construction", filter:'agNumberColumnFilter', width:250},
          {headerName:"State Specific",field:"State Specific", filter:'agNumberColumnFilter', width:250},
          
        ];                                                                                  
        this.showGrid=true;
      }else if(dataObj == 36){
      
        this.uniHeader="All Type Boundary Wall All Year All State Category Mgmt";
        this.universalAgGridColumnDefs=[
          {headerName:"Academin year",field:"ac_year", filter:'agNumberColumnFilter', width:250},
          {headerName:"State Name",field:"state_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"No Boundary Wall",field:"No Boundary Wall", filter:'agNumberColumnFilter', width:250},
          {headerName:"Not Applicable",field:"Not Applicable", filter:'agNumberColumnFilter', width:250},
          {headerName:"Pucca",field:"Pucca", filter:'agNumberColumnFilter', width:250},
          {headerName:"Pucca but Broken",field:"Pucca but Broken", filter:'agNumberColumnFilter', width:250},
          {headerName:"Barbed Wire Fencing",field:"Barbed Wire Fencing", filter:'agNumberColumnFilter', width:250},
          {headerName:"Hedges",field:"Hedges", filter:'agNumberColumnFilter', width:250},
          {headerName:"Others",field:"Others", filter:'agNumberColumnFilter', width:250},
          {headerName:"Partial",field:"Partial", filter:'agNumberColumnFilter', width:250},
          {headerName:"Under Construction",field:"Under Construction", filter:'agNumberColumnFilter', width:250},
          {headerName:"State Specific",field:"State Specific", filter:'agNumberColumnFilter', width:250},
          {headerName:"Category Id",field:"category_id", filter:'agNumberColumnFilter', width:250},
          {headerName:"Category Name",field:"category_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"School Management Id",field:"sch_mgmt_id", filter:'agNumberColumnFilter', width:250},
          {headerName:"School Management Name",field:"sch_mgmt_name", filter:'agNumberColumnFilter', width:250},
          {headerName:"Min Management",field:"min_mgmt_id", filter:'agNumberColumnFilter', width:250},
          {headerName:"Min Management Name",field:"min_mgmt_name", filter:'agNumberColumnFilter', width:250}
        ];                                                                                  
        this.showGrid=true;
      }

      this.ngxLoader.stop();
    },
      error => {
        alert('get error in tabularData--->');
        this.ngxLoader.stop();
      })

    // DataTable 
    // this.loadDataTable();
  }
 

  schoolOverTime(){
    return [
      'Operational',
      'Closed',
      'Merged',
      'Sanctioned',
      'DCF Not Found',
      'Not Engaged'
    ]
  }
  
  stateName(){
    return [
      'Andaman & Nicobar Islands',
      'Andhra Pradesh',
      'Arunachal Pradesh',
      'Assam',
      'Bihar',
      'Chandigarh',
      'Chhattisgarh',
      'Dadra & Nagar Haveli',
      'Daman & Diu',
      'Delhi',
      'Goa',
      'Gujarat',
      'Haryana',
      'Himachal Pradesh',
      'Jammu & Kashmir',
      'Jharkhand',
      'Karnataka',
      'Kerala',
      'Lakshadweep',
      'Madhya Pradesh',
      'Maharashtra',
      'Manipur',
      'Meghalaya',
      'Mizoram',
      'Nagaland',
      'Orissa',
      'Puducherry',
      'Punjab',
      'Rajasthan',
      'Sikkim',
      'Tamilnadu',
      'Telangana',
      'Tripura',
      'Uttar Pradesh',
      'Uttarakhand',
      'West Bengal'
      
    ];

    
  }

  getChartsData(dataObj,dependencyValue,isDependency) {
    if (JSON.parse(sessionStorage.getItem('currentUser')) == null) {
      this.paramName = "civilian";
      this.paramValue = "";
      this.schemaName="";
    }else{
      this.paramName = JSON.parse(sessionStorage.getItem('currentUser')).paramName;
      this.paramValue = JSON.parse(sessionStorage.getItem('currentUser')).paramValue;
      this.schemaName=JSON.parse(sessionStorage.getItem('currentUser')).schema_name;
    }
    if(isDependency !="Y" && dataObj==6){
      this.staticReportDependency={"year":"2018-19","state":"All"}
      dependencyValue=JSON.stringify(this.staticReportDependency);
    }else if(isDependency !="Y" && dataObj==7){
      this.staticReportDependency={"year":"2018-19","state":"All"}
      dependencyValue=JSON.stringify(this.staticReportDependency);
    }
// alert("Dependency value--->"+dependencyValue);

    this.conditionObj = {
      mapId: dataObj,
      dependencyValue: dependencyValue,
      isDependency: isDependency,
      paramName:this.paramName ,
      paramValue: this.paramValue,
      schemaName: this.schemaName
    }

    // this.ngxLoader.start();
    this.reportService.getChartsData(this.conditionObj).subscribe(res => {
      this.listColumeNames = res.columnName;
      this.columnValues = res.rowValue;
      this.selectedDeviceObj = res.rowValue;
      this.ChartName = dataObj.report_name;
      if (dataObj == 1) {
        for (let i = 0; i < res.rowValue.length; i++) {
          this.chartTempData = [];
          this.chartTempData.push(parseInt(res.rowValue[i].estd_year));
          this.chartTempData.push(res.rowValue[i].noofschool);
          this.chartData2.push(this.chartTempData)
          this.chartTempData = [];
          this.chartTempData.push(parseInt(res.rowValue[i].estd_year));
          this.chartTempData.push(res.rowValue[i].cumulative_sum);
          this.chartData1.push(this.chartTempData)
        }
        Highcharts.chart('chart1', this.options);
        Highcharts.chart('chart2', this.options2);
        //chartData1
      }else if(dataObj == 6){
        // alert(JSON.stringify(res))
        for(let i=0;i<5;i++){
          this.mapArray=[];
          // ['The Left', 69, '#BE3075', 'DIE LINKE']
          // alert("Data for push--->"+res.rowValue[i].state_name)
          this.mapArray.push(res.rowValue[i].state_name);
          this.mapArray.push(res.rowValue[i].count);
          this.mapArray.push('#BE3075');
          this.mapArray.push(res.rowValue[i].state_name);
          this.Indaidata[i]=this.mapArray;
         }

         
         Highcharts.chart('noSchoolChartContainer', this.noSchoolChartOption);
      }else if(dataObj == 7){
        // this.listColumeNames = res.columnName;
// alert(JSON.stringify(res.rowValue))
        for(let i=0;i<res.rowValue.length;i++){
          this.mapArray=[];
          this.mapArray.push.apply(this.mapArray, ['Primary only with grades 1 to 5 total-'+res.rowValue[i].one+"     ",Math.ceil(((+res.rowValue[i].one)/(+res.rowValue[i].total))*500),'#BE3075','Primary only with grades 1 to 5 total 500*'])
          this.Indaidata[0]=this.mapArray;
          this.universalCharData[0]={  name: 'Primary only with grades 1 to 5',y:(((+res.rowValue[i].one)/(+res.rowValue[i].total))*100)}
          this.mapArray=[];
          this.mapArray.push.apply(this.mapArray, ['Upper Primary with grades 1 to 8total-'+res.rowValue[i].two+"     ",Math.ceil(((+res.rowValue[i].two)/(+res.rowValue[i].total))*500),'##F633FF','Upper Primary with grades 1 to 8'])
          this.Indaidata[1]=this.mapArray;
          this.universalCharData[1]={  name: 'Upper Primary with grades 1 to 8',y:(((+res.rowValue[i].two)/(+res.rowValue[i].total))*100)}
          this.mapArray=[];
          this.mapArray.push.apply(this.mapArray, ['Higher Secondary with grades 1 to 12total-'+res.rowValue[i].three+"     ",Math.ceil(((+res.rowValue[i].three)/(+res.rowValue[i].total))*500),'#8A33FF','Higher Secondary with grades 1 to 12'])
          this.Indaidata[2]=this.mapArray;
          this.universalCharData[2]={  name: 'Higher Secondary with grades 1 to 12',y:(((+res.rowValue[i].three)/(+res.rowValue[i].total))*100)}
          this.mapArray=[];
          this.mapArray.push.apply(this.mapArray, ['Upper Primary only with grades 6 to 8total-'+res.rowValue[i].four+"     ",Math.ceil(((+res.rowValue[i].four)/(+res.rowValue[i].total))*500),'#33D7FF','Upper Primary only with grades 6 to 8'])
          this.Indaidata[3]=this.mapArray;
          this.universalCharData[3]={  name: 'Upper Primary only with grades 6 to 8',y:(((+res.rowValue[i].four)/(+res.rowValue[i].total))*100)}
          this.mapArray=[];
          this.mapArray.push.apply(this.mapArray, ['Higher Secondary with grades 6 to 12total-'+res.rowValue[i].five+"     ",Math.ceil(((+res.rowValue[i].five)/(+res.rowValue[i].total))*500),'#33FF83','Higher Secondary with grades 6 to 12'])
          this.Indaidata[4]=this.mapArray;
          this.universalCharData[4]={  name: 'Higher Secondary with grades 6 to 12',y:(((+res.rowValue[i].five)/(+res.rowValue[i].total))*100)}
          this.mapArray=[];
          this.mapArray.push.apply(this.mapArray, ['Secondary/Sr. Sec. with grades 1 to 10total-'+res.rowValue[i].six+"     ",Math.ceil(((+res.rowValue[i].six)/(+res.rowValue[i].total))*500),'#B5FF33','Secondary/Sr. Sec. with grades 1 to 10'])
          this.Indaidata[5]=this.mapArray;
          this.universalCharData[5]={  name: 'Secondary/Sr. Sec. with grades 1 to 10',y:(((+res.rowValue[i].six)/(+res.rowValue[i].total))*100)}
          this.mapArray=[];
          this.mapArray.push.apply(this.mapArray, ['Secondary/Sr. Sec. with grades 6 to 10total-'+res.rowValue[i].seven+"     ",Math.ceil(((+res.rowValue[i].seven)/(+res.rowValue[i].total))*500),'#FFE033','Secondary/Sr. Sec. with grades 6 to 10'])
          this.Indaidata[6]=this.mapArray;
          this.universalCharData[6]={  name: 'Secondary/Sr. Sec. with grades 6 to 10',y:(((+res.rowValue[i].seven)/(+res.rowValue[i].total))*100)}
          this.mapArray=[];
          this.mapArray.push.apply(this.mapArray, ['Secondary/Sr. Sec. only with grades 9 & 10total-'+res.rowValue[i].eigth+"     ",Math.ceil(((+res.rowValue[i].eigth)/(+res.rowValue[i].total))*500),'#FF9F33','Secondary/Sr. Sec. only with grades 9 & 10'])
          this.Indaidata[7]=this.mapArray;
          this.universalCharData[7]={  name: 'Secondary/Sr. Sec. only with grades 9 & 10',y:(((+res.rowValue[i].eight)/(+res.rowValue[i].total))*100)}
          this.mapArray=[];
          this.mapArray.push.apply(this.mapArray, ['Higher Secondary with grades 9 to 12total-'+res.rowValue[i].ten+"     ",Math.ceil(((+res.rowValue[i].ten)/(+res.rowValue[i].total))*500),'#FF7433','Higher Secondary with grades 9 to 12'])
          this.Indaidata[8]=this.mapArray;
          this.universalCharData[8]={  name: 'Higher Secondary with grades 9 to 12',y:(((+res.rowValue[i].ten)/(+res.rowValue[i].total))*100)}
          this.mapArray=[];
          this.mapArray.push.apply(this.mapArray, ['Hr. Sec. or Jr. College only with grades total-'+res.rowValue[i].eleven+"     ",Math.ceil(((+res.rowValue[i].eleven)/(+res.rowValue[i].total))*500),'#F0FF33','Hr. Sec. or Jr. College only with grades'])
          this.Indaidata[9]=this.mapArray;
          this.universalCharData[9]={  name: 'Hr. Sec. or Jr. College only with grades',y:(((+res.rowValue[i].eleven)/(+res.rowValue[i].total))*100)}
          
         }     
         this.univerSalChartType="pie";
         this.universalChartText="Category wise School %";
         
        //  alert("this.Indaidata--->"+JSON.stringify(this.Indaidata));   
         Highcharts.chart('noSchoolChartContainer', this.noSchoolChartOption);
         Highcharts.chart('univerPieChartOption',this.univerPieChartOption);
      } else {
        this.showCharts("All", dataObj.report_name);
      }
      this.ngxLoader.stop();
    },
      error => {
        this.ngxLoader.stop();
        alert('error in chart --->');

      })
  }


  changeDatas(event, dataId, changeFlag) {
    // this.destroyDataTable();
    //alert(event.target.options[event.target.selectedIndex].getAttribute('data-somedata'))  // working to get Attribute
    debugger;
    let condtionsValue: String = event.target.value;
    if (condtionsValue == "All" && dataId == "2-1") {
      this.thlabel = "State Name"
      this.stateCode = condtionsValue;
      this.getMasterData('GET_DISTRICT', '');
    } else if (condtionsValue != "All" && dataId == "2-1") {
      this.thlabel = "District Name";
      this.getMasterData('GET_DISTRICT', "where udise_state_code= '" + event.target.value + "'");
      this.stateCode = condtionsValue;
    } else if (dataId == "2-2") {
      this.thlabel = "Block Name"
      if (condtionsValue == "All") {
        condtionsValue = condtionsValue + "-" + this.stateCode;
      }
    } else if (dataId == "6") {
      this.Indaidata=[];
           if(changeFlag=="Y"){
            this.yearValue=condtionsValue;
           }else if(changeFlag=="S"){
            this.StateValue=condtionsValue;
           }
           this.staticReportDependency={"year":this.yearValue,"state":this.StateValue}
           condtionsValue=JSON.stringify(this.staticReportDependency);
    }else if(dataId == "7"){
      if(changeFlag=="Y"){
        this.yearValue=condtionsValue;
       }else if(changeFlag=="S"){
        this.StateValue=condtionsValue;
       }
       this.staticReportDependency={"year":this.yearValue,"state":this.StateValue}
       condtionsValue=JSON.stringify(this.staticReportDependency);
      //  alert(JSON.stringify(condtionsValue));
    }
    this.getTabularData(dataId, condtionsValue, 'Y');
  }

  ChartDataChange(event, dataId, changeFlag){
    let condtionsValue: String = event.target.value;
   if(dataId == "7"){
      if(changeFlag=="Y"){
        this.yearValue=condtionsValue;
       }else if(changeFlag=="S"){
        this.StateValue=condtionsValue;
       }
       this.staticReportDependency={"year":this.yearValue,"state":this.StateValue}
       condtionsValue=JSON.stringify(this.staticReportDependency);
      //  alert(JSON.stringify(condtionsValue));
    }
    this.getChartsData(dataId, condtionsValue, 'Y');
  }

  getMasterData(extensionCall, condition) {
    this.masterCondition = {
      extensionCall: extensionCall,
      condition: condition
    };
    this.reportService.getMasterData(this.masterCondition).subscribe(res => {
      if (extensionCall == "GET_STATE") {
        this.state = res.rowValue;
      } else if (extensionCall == "GET_DISTRICT") {
        this.district = res.rowValue;
      }
      // alert(JSON.stringify(this.state));
    },
      error => {
        alert('error in getMasterData--->');
      })
  }

  getDistrict(event){
  this.getMasterData('GET_DISTRICT', "where udise_state_code= '" + event.target.value + "'");
  }


  showCharts(dataObject, report_name) {
    let tot_clsrm_minor = 0;
    let tot_clsrm_major = 0;
    let goodcondition = 0;
    if (dataObject == "All") {
      this.selectedDeviceObj.forEach(obj => {
        tot_clsrm_minor += obj.tot_clsrm_minor;
        tot_clsrm_major += obj.tot_clsrm_major;
        goodcondition += obj.goodcondition;
      })
    } else {
      tot_clsrm_minor += this.selectedDeviceObj[dataObject.target.value].tot_clsrm_minor;
      tot_clsrm_major += this.selectedDeviceObj[dataObject.target.value].tot_clsrm_major;
      goodcondition += this.selectedDeviceObj[dataObject.target.value].goodcondition;
    }

    let chart = new Chart({
      chart: {
        type: 'pie'
      },
      title: {
        text: this.ChartName
      },
      credits: {
        enabled: false
      }, plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
          }
        }
      },
      series: [{
        name: 'Brands',
        colorByPoint: true,
        type: undefined,
        data: [{
          name: 'Minor Repair',
          y: tot_clsrm_minor,
          sliced: true,
          selected: true
        }, {
          name: 'Major Repair',
          y: tot_clsrm_major
        }, {
          name: 'Good Condition',
          y: goodcondition
        }]
      }]
    });
    this.chart = chart;
  }

  loadDataTable() {
    setTimeout(function () {
      if ($.fn.dataTable.isDataTable($('.table1'))) {
        $('.table1').DataTable({
          dom: 'Bfrtip',
          responsive: true,
          paging: true,
          "scrollY": "450px"
        });
      } else {
        $('.table1').DataTable({
          dom: 'Bfrtip',
          responsive: true,
          paging: true,
          "scrollY": "450px"
        });
      }
    }, 1000);
  }

  destroyDataTable() {
    $('.table1').DataTable().destroy();
    //  $('.table1 > tbody').html("");
  }

  selectReport(value){
    // alert("report selected");
    this.tag=value;
    if(value=="All"){
      this.filterReportCount=this.staticReportValues.length
    }else{
      this.filterReportCount=this.staticReportValues.filter(singleItem => singleItem["tag"].toLowerCase().includes(value.toLowerCase())).length
    }
  }
  


}
